/*
 * CUSTOM CODE
 * Groups the featured-product section's gallery/thumbnail/modal images by
 * variant, replicating a "variant image app": starting at the selected
 * variant's own assigned image, every following image in the product's
 * image list stays visible until the next variant-assigned image is
 * reached (that one starts the next variant's group and is excluded).
 *
 * Scoped entirely to sections/featured-product.liquid - reads the JSON
 * data block that section renders (id="VariantGalleryData-<section.id>")
 * and only touches elements within that section's own gallery/modal.
 * Does not modify any shared theme file.
 */
(function () {
  if (window.__featuredProductVariantGalleryLoaded) return;
  window.__featuredProductVariantGalleryLoaded = true;

  var HIDDEN_CLASS = 'fp-variant-gallery-hidden';

  function initOne(dataScript) {
    var sectionId = dataScript.id.replace('VariantGalleryData-', '');

    var config;
    try {
      config = JSON.parse(dataScript.textContent);
    } catch (e) {
      return;
    }
    if (!config || !config.imageIds || !config.imageIds.length) return;

    var allImageIds = {};
    config.imageIds.forEach(function (id) {
      allImageIds[id] = true;
    });

    var taggedImageIds = {};
    (config.taggedImageIds || []).forEach(function (id) {
      taggedImageIds[id] = true;
    });

    function computeVisibleIds(variantId) {
      var startId = config.variantImageMap[variantId];
      if (startId == null) return null;

      var startIndex = config.imageIds.indexOf(startId);
      if (startIndex === -1) return null;

      var visible = {};
      for (var i = startIndex; i < config.imageIds.length; i++) {
        var id = config.imageIds[i];
        if (i !== startIndex && taggedImageIds[id]) break;
        visible[id] = true;
      }
      return visible;
    }

    function extractImageId(compositeId) {
      if (!compositeId) return null;
      var prefix = sectionId + '-';
      if (compositeId.indexOf(prefix) !== 0) return null;
      var num = Number(compositeId.slice(prefix.length));
      return isNaN(num) ? null : num;
    }

    // null visibleIds = couldn't resolve a range (missing/unorganized data) -> fail open, show everything.
    // An id that isn't one of the product's tracked images (e.g. non-image media) is never hidden either.
    function shouldHide(imageId, visibleIds) {
      if (imageId == null || !allImageIds[imageId]) return false;
      if (!visibleIds) return false;
      return !visibleIds[imageId];
    }

    function applyToGalleries(visibleIds) {
      var galleries = document.querySelectorAll('[id^="MediaGallery-' + sectionId + '"]');
      galleries.forEach(function (gallery) {
        var changed = false;

        // Matches both gallery slides (Slide-<section>-<media>) and thumbnail
        // slides (Slide-Thumbnails-<section>-<n>) - the same id prefix the
        // theme's own slider-component uses to find its slides, so this
        // intentionally skips nested elements (zoom button, deferred-media)
        // that also carry a data-media-id but aren't slide wrappers.
        gallery.querySelectorAll('[id^="Slide-"]').forEach(function (slide) {
          var compositeId = slide.hasAttribute('data-media-id')
            ? slide.getAttribute('data-media-id')
            : slide.getAttribute('data-target');
          var hide = shouldHide(extractImageId(compositeId), visibleIds);
          if (slide.classList.contains(HIDDEN_CLASS) !== hide) changed = true;
          slide.classList.toggle(HIDDEN_CLASS, hide);
        });

        if (!changed) return;
        gallery.querySelectorAll('slider-component').forEach(function (slider) {
          if (typeof slider.resetPages === 'function') slider.resetPages();
        });
      });
    }

    function applyToModal(visibleIds) {
      var modalContent = document.querySelector(
        '#ProductModal-' + sectionId + ' .product-media-modal__content'
      );
      if (!modalContent) return;

      modalContent.querySelectorAll('[data-media-id]').forEach(function (item) {
        var imageId = Number(item.getAttribute('data-media-id'));
        var hide = shouldHide(isNaN(imageId) ? null : imageId, visibleIds);
        item.classList.toggle(HIDDEN_CLASS, hide);
      });
    }

    function applyVisibility(variantId) {
      var visibleIds = computeVisibleIds(variantId);
      applyToGalleries(visibleIds);
      applyToModal(visibleIds);
    }

    function getPicker() {
      return (
        document.querySelector('variant-radios[data-section="' + sectionId + '"]') ||
        document.querySelector('variant-selects[data-section="' + sectionId + '"]')
      );
    }

    function getInitialVariantId() {
      var urlVariantId = Number(new URLSearchParams(window.location.search).get('variant'));
      if (urlVariantId && config.variantImageMap[urlVariantId] != null) return urlVariantId;
      return config.initialVariantId;
    }

    applyVisibility(getInitialVariantId());

    var picker = getPicker();
    if (!picker) return;

    picker.addEventListener('change', function () {
      if (!picker.currentVariant) return;
      applyVisibility(picker.currentVariant.id);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('script[id^="VariantGalleryData-"]').forEach(initOne);
  }

  initAll(document);

  // Re-init after the theme editor swaps a section's HTML (e.g. toggling the
  // "Group gallery images by variant" setting or changing the product).
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
